import React from 'react';

import { useDomainNameVerificationQuery } from '@dashboard/generated/wp/administrator';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import RecordRow from './RecordRow';

type Props = {
  id: string;
};
export function RecordsTable({ id }: Props) {
  const { data } = useDomainNameVerificationQuery({ variables: { id } });
  const model = data?.DomainNameVerification;

  const renderVerificationRows = () => {
    if (!model) {
      return null;
    }
    return model.verificationDnsRecords.map((r, i) => (
      <RecordRow
        key={i}
        isPresent={r.isPresent}
        type={r.type}
        name={r.name}
        value={r.value}
        domainName={model.domainName}
      />
    ));
  };

  const renderMailFromRows = () => {
    const records = model?.mailFromConfiguration?.records;
    if (!records) {
      return null;
    }
    return records.map((r, i) => (
      <RecordRow
        key={i}
        isPresent={r.isPresent}
        type={r.type}
        name={r.name}
        value={r.value}
        domainName={model.domainName}
      />
    ));
  };

  return (
    <TableContainer>
      <Table size="small" sx={{ '& th, & td': { border: 0 } }}>
        <TableHead>
          <TableRow>
            <TableCell align="center" variant="head" width={64}>
              Status
            </TableCell>
            <TableCell variant="head" width={96}>
              Type
            </TableCell>
            <TableCell variant="head">Hostname</TableCell>
            <TableCell variant="head">Value</TableCell>
            <TableCell variant="head">DNS Lookup</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderVerificationRows()}
          {renderMailFromRows()}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
